export const iconFontAwesomeMapsGift = (
	<i className="fa-solid fa-gift"></i>
);
